/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Info_Package_Count_HintInputs */

const vi_print_info_package_count_hint = /** @type {(inputs: Print_Info_Package_Count_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi kiện in một tờ nhãn. Chỉ áp dụng cho lần in này.`)
};

/**

* @param {Print_Info_Package_Count_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_info_package_count_hint = /** @type {((inputs?: Print_Info_Package_Count_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Info_Package_Count_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_info_package_count_hint(inputs)
});